(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eclat-header-pro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const header = document.querySelector('.ec-head');
    if (!header) return;
    if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
    if (event.target.closest('.ec-head__nav a')) header.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
    const summary = event.target.closest('.ec-head__dropdown > summary');
    if (summary) header.querySelectorAll('.ec-head__dropdown[open]').forEach((detail) => { if (detail !== summary.parentElement) detail.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = document.querySelector('.ec-head');
    if (!header) return;
    const mobileMenu = header.querySelector('.ec-head__mobile-menu[open]');
    const opened = mobileMenu || header.querySelector('.ec-head__dropdown[open]');
    header.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
    if (opened) opened.querySelector('summary').focus();
  });
  } catch(e) { console.error(e); }
})();

})();
